<template>
  <div>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <h4 class="d-flex align-items-center">
        <span 
          >{{ newBlogData.id > 0 ? "編輯" : "新增" }}通告</span
        >
      </h4>
      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="mt-3" @submit.prevent="handleSubmit(onSubmit)" key="2">
          <div class="mt-2 mt-sm-3 position-relative">
            <b-row>

              <b-col cols="12">
                <validation-provider
                  #default="validationContext"
                  name="通告日期"
                  rules="required"
                >
                <b-form-group
                  label="通告日期"
                  label-for="blog_date"
                  label-cols-md="2"
                >
                <flat-pickr
                  v-model="newBlogData.blog_date"
                  class="form-control"
                  :config="{
                    allowInput: true,
                    dateFormat: 'Y-m-d',
                  }"
                  placeholder="輸入通告日期"
                  
                />
                  <b-form-invalid-feedback :state="getValidationState(validationContext)">  
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <validation-provider
                  #default="validationContext"
                  name="標題"
                  rules="required"
                >
                <b-form-group
                  label="標題"
                  label-for="title"
                  label-cols-md="2"
                >
                  <b-form-input
                    id="title"
                    v-model="newBlogData.title"
                    class="form-control"
                    placeholder="輸入標題"
                    :state="getValidationState(validationContext)"
                  />
                  <b-form-invalid-feedback>  
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12">
                <validation-provider
                  #default="validationContext"
                  name="內容"
                  rules="required"
                >
                <b-form-group
                  label="內容"
                  label-for="content"
                  label-cols-md="2"
                >
                <quill-editor 
                  v-model="newBlogData.content" 
                  :options="editorOption" 
                  ref="QuillEditor">
                </quill-editor>
                  <b-form-invalid-feedback>  
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="狀態"
                  label-for="is_active"
                  label-cols-md="2"
                >
                  <b-form-checkbox
                    :checked="newBlogData.is_active"
                    name="is_active"
                    switch
                    inline
                    v-model="newBlogData.is_active"
                    style="margin-top: 5px"
                  >
                    {{ newBlogData.is_active ? "啟用" : "禁用" }}
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

            </b-row>
          </div>

          <div class="d-flex mt-1 flex-wrap flex-lg-nowrap justify-content-end">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-sm-2 mobile-w100"
              type="submit"
            >
              <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
              提交
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
              class="mt-1 mt-sm-0 mobile-w100"
            >
              取消
            </b-button>
          </div>
        </b-form>
      </b-overlay>
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BButton,
  BOverlay,
  BFormTextarea
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ref, watch } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import Ripple from "vue-ripple-directive";
import "animate.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import { required, email } from "@validations";
import ability from "@/libs/acl/ability";
import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";



export default {
  data() {
    return {
      required,
      ability,
    };
  },
  directives: {
    Ripple,
  },
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormInvalidFeedback,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BRow,
    BCol,
    BButton,
    BOverlay,
    BFormTextarea,
    flatPickr,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    quillEditor
  },
  computed: {
  },
  methods: {
    hide() {
      this.$router.replace("/blogs");
    },
    onSubmit() {
      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          store
            .dispatch("blog/editBlog", this.newBlogData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });

              this.hide();

            /*   if (this.newBlogData.id == 0) {
                this.newBlogData.id = response.data.id;
                this.redirect(response.data.id);
              } */
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
      
    makeToast(variant = null, title = null, content = null) {
      this.$bvToast.toast(content, {
        title: title,
        variant,
        solid: true,
      });
    },
  },
  props: {
    blogData: {
      type: Object,
      required: true,
    },
  },

  setup(props, { emit }) {
    const newBlogData = ref({
      id: 0,
      is_active: true,
      blog_date: null,
      content: null,
      title: null,
    });
    const editorOption = ref({
      modules: {
        toolbar: {
          container: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],                    
            [{ 'header': 1 }, { 'header': 2 }],               
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],    
            [{ 'script': 'sub' }, { 'script': 'super' }],    
            [{ 'indent': '-1' }, { 'indent': '+1' }],      
            [{ 'direction': 'rtl' }],                      
            [{ 'size': ['small', false, 'large', 'huge'] }], 
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }], 
            [{ 'font': ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial'] }],
            [{ 'align': [] }],
            ['clean'],
            ['link'] // , 'image'
          ],
          handlers: {
            image: (value) => {
              //console.log("image", value);
              if (value) {
               document.querySelector('.avatar-uploader input').click()
              } else {
                this.quill.format("image", false);
              }
            },
          },
        },
      },
    });

    watch(
      () => props.blogData,
      (newVal) => {
        newBlogData.value = { ...newVal };
      }
    );
    const resetWorkData = () => {
      newBlogData.value = JSON.parse(
        JSON.stringify({
          id: 0,
          is_active: 1,
          blog_date: null,
          content: null,
          title: null,
        })
      );
    };

    const loading = ref(false);

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetWorkData);

    return {
      loading,
      refFormObserver,
      getValidationState,
      resetForm,
      newBlogData,
      editorOption
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style lang="scss" scoped>

</style>
